import { ChangeEvent, useEffect, useState } from 'react'
import { AnimatedFragment } from '../Animator/AnimatedFragment'
import { IInputProps } from './Input'
import './Inputs.scss'

export const TextInput = (props: IInputProps) => {
  const [valid, setValid] = useState(true)
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    if (props.onValidUpdate && props.name) {
      props.onValidUpdate(props.name, valid)
    }
  }, [valid])

  useEffect(() => {
    validate(props.value)
    setValue(props.value ?? '')
  }, [props.value])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.currentTarget.value
    props.onChange(val)
    setValue(val)
    validate(val)
  }

  const validate = (value?: string) => {
    if (props.required && !value) {
      return setValid(false)
    }

    setValid(true)
  }

  //Dirty fix, Necessary due to filter input losing focus on click (library issue)
  const simulateDoubleClick = () => {
    if (props.id) {
      const targetInput = document.getElementById(props.id)
      setTimeout(() => {
        targetInput?.focus()
      }, 1)
    }
    if (props.onClick) {
      props.onClick()
    }
  }

  // const onClick = () => {
  //   if (props.onClick) {
  //     props.onClick()
  //   }
  // }

  return (
    <AnimatedFragment visible={props.visible === undefined ? true : props.visible}>
      <div
        className={['formArea', !props.validate || valid ? '' : 'not-valid', props.required ? 'required' : ''].join(
          ' '
        )}
      >
        <div className="form-group">
          {!!props.label && (
            <label>
              <div className="label">{props.label || ''}</div>
            </label>
          )}
          <input
            type="text"
            value={value}
            placeholder={props.placeholder}
            readOnly={props.readonly}
            title={props.title}
            className={['text-input', props.className].join(' ')}
            onChange={onChange}
            onClick={() => simulateDoubleClick()}
            id={props.id}
          />
        </div>
      </div>
    </AnimatedFragment>
  )
}
